/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ClassroomdisciplineId202,
  DeleteApiV1ClassroomdisciplineId401,
  DeleteApiV1ClassroomdisciplineId404,
  DeleteApiV1ClassroomdisciplineId500,
  DeleteApiV1ClassroomdisciplineIdMutationResponse,
  DeleteApiV1ClassroomdisciplineIdPathParams,
} from "../../types/classPlanningController/DeleteApiV1ClassroomdisciplineId.ts";

export const deleteApiV1ClassroomdisciplineIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ClassroomdisciplineId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ClassroomdisciplineId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ClassroomdisciplineId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ClassroomdisciplineId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineId500>;

export const deleteApiV1ClassroomdisciplineIdMutationResponseSchema = z.lazy(
  () => deleteApiV1ClassroomdisciplineId202Schema,
) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdMutationResponse>;
